import { Divider, Grid, Typography } from "@mui/material";
import genericStyles from "../../Styles/genericStyles.module.css";
import { PropertyContainerProps } from "../../Utils/Types";

export default function PropertyContainer(props: PropertyContainerProps) {
  const { property, propertyInput, propertyIcon } = props;
  return (
    <>
      <Grid item xs={3} className={genericStyles.gridContainer}>
        <Typography>{property}</Typography>
        {propertyIcon}
      </Grid>
      <Divider orientation="vertical" flexItem />
      <Grid item xs={8} className={genericStyles.gridContainer}>
        {propertyInput}
      </Grid>
    </>
  );
}
